/**
 * Telling a real graphics card from one the browser only emulates.
 *
 * Without a usable graphics card (no driver, a virtual machine, a blocked card), browsers still
 * offer WebGL, drawn by the processor (SwiftShader in Chromium, llvmpipe in Mesa, WARP on
 * Windows). That is slower than Canvas 2D, so the graph only uses the GPU on real hardware.
 */

/** Names of graphics "cards" that are the processor in disguise. */
const SOFTWARE = /swiftshader|llvmpipe|softpipe|lavapipe|software|basic render|microsoft basic/i;

/** Whether `device` (the renderer name WebGL reports) is a processor emulating a graphics card. */
export function isSoftwareDevice(device: string): boolean {
  return SOFTWARE.test(device);
}
